import { SystemStore } from '@/common/stores/system.store';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';

@Component({
  selector: "app-pagenotfound",
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {
  authenticated: boolean = false;

  constructor(
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store
      .selectOnce(SystemStore.isAuthenticated)
      .subscribe(authenticated => {
        this.authenticated = authenticated;
      });
  }
}
